// src/ExamQuestions3.jsx
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import styles from '../css/modules/ExamQuestions.module.css';

const ExamQuestions4 = () => {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate('/praktyka-i-teoria-patentu-strzeleckiego');
  };

  return (
    <div className={styles.contactContainer}>
      <Helmet>
        <title>Marzysz o patencie strzeleckim? Nasze pytania na broń pomogą Ci to osiągnąć!</title>
        <meta
          name="description"
          content="Czwarta część pytań egzaminacyjnych na patent strzelecki z wyjaśnieniami i ikonami. Dowiedz się, jak bezpiecznie używać, przewozić i przechowywać broń."
        />
      </Helmet>

      <div className={styles.content}>
        <h1 className="mainHeader">Patent strzelecki łatwiej zdany – ucz się przyjemnie, pytania na broń w jednym miejscu!</h1>

                <div className="intro">
          <p>
            Witaj w czwartej odsłonie naszego intensywnego cyklu przygotowującego do <strong>egzaminu na patent strzelecki</strong>! 🚀 Tym razem skupiamy się na kluczowych umiejętnościach i zasadach: noszeniu, przewożeniu, używaniu oraz przechowywaniu broni palnej – zarówno na strzelnicy, jak i w życiu codziennym. To nie tylko teoria, ale praktyczna wiedza, która realnie zwiększy Twoje bezpieczeństwo i pomoże Ci działać zgodnie z prawem.
          </p>
          <p>
            📘 Specjalnie dla Ciebie opracowaliśmy pełną, aktualną listę oficjalnych pytań Polskiego Związku Strzelectwa Sportowego (PZSS), wzbogaconą o przejrzyste wyjaśnienia i komentarze. Dzięki temu przygotowanie do <strong>egzaminu na broń</strong> staje się nie tylko skuteczniejsze, ale też bardziej zrozumiałe i przystępne – nawet jeśli dopiero zaczynasz swoją przygodę z bronią.
          </p>
          <p>
            🔗 Jeżeli jesteś na początku swojej drogi, koniecznie sięgnij po nasz <a href="/pytania-na-pozwolenie-na-bron-patent-strzelecki">przewodnik o egzaminie na broń</a>, który krok po kroku przeprowadzi Cię przez wszystkie wymagania i zagadnienia. A jeśli chcesz dowiedzieć się więcej o procedurach i formalnościach, sprawdź także, <a href="/pozwolenie-na-bron-i-ustawa-o-broni-i-amunicji">jak zdobyć pozwolenie na broń</a>.
          </p>
          <p>
            🎮 Wierzymy, że nauka może być nie tylko efektywna, ale i ciekawa. Dlatego stworzyliśmy <a href="https://pistolet.org" target="_blank" rel="noopener noreferrer">interaktywne testy na patent strzelecki</a> w formie dynamicznych quizów z wyjaśnieniami, które pozwolą Ci sprawdzić wiedzę w praktyce i utrwalić najważniejsze informacje w przyjemny sposób.
          </p>
        </div>
        <h2>📋 Zasady używania, noszenia i cofnięcia pozwolenia</h2>
        <h2>📋 Zasady używania, noszenia i cofnięcia pozwolenia</h2>
      <ul class="reasonList">

        <li class="customAnswer">
          <h3>47. ❌ Naruszenie zasad używania broni na strzelnicy</h3>
          <p>
            Zgodnie z ustawą o broni i amunicji, broń palna oraz inna broń zdolna do rażenia celów na odległość powinna być używana wyłącznie na strzelnicach w celach szkoleniowych lub sportowych. Używanie broni poza strzelnicą przez osobę posiadającą pozwolenie wydane wyłącznie do celów sportowych lub szkoleniowych jest naruszeniem przepisów i może skutkować cofnięciem pozwolenia przez Policję.
          </p>
        </li>

        <li class="customAnswer">
          <h3>48. 🚶‍♂️ Definicja noszenia broni</h3>
          <p>
            W rozumieniu ustawy o broni i amunicji, noszenie broni oznacza każdy sposób przemieszczania załadowanej broni palnej przez osobę posiadającą stosowne pozwolenie. Przez „załadowaną” należy rozumieć broń przygotowaną do oddania strzału, niezależnie od sposobu jej przenoszenia — w rękach, kaburze, torbie lub w innym miejscu, które umożliwia szybkie użycie broni.
          </p>
        </li>

        <li class="customAnswer">
          <h3>49. 🚫 Obowiązkowe cofnięcie pozwolenia na broń</h3>
          <p>
            Policja ma obowiązek cofnąć pozwolenie na broń, jeśli okaże się, że jego posiadacz został prawomocnie skazany za przestępstwo, stwierdzono u niego zaburzenia psychiczne lub istotne zaburzenia funkcjonowania psychologicznego, jest uzależniony od alkoholu lub substancji psychoaktywnych, nie posiada miejsca stałego pobytu w Polsce lub stanowi zagrożenie dla bezpieczeństwa publicznego.
          </p>
        </li>

        <li class="customAnswer">
          <h3>50. ⚠️ Kiedy Policja może cofnąć pozwolenie na broń?</h3>
          <p>
            Zgodnie z ustawą o broni i amunicji, Policja może cofnąć pozwolenie na broń w przypadkach takich jak naruszenie obowiązku rejestracji broni, nieprzestrzeganie zasad przechowywania i ewidencjonowania broni i amunicji, brak przedstawienia aktualnych orzeczeń lekarskich lub psychologicznych, a także w sytuacji, gdy ustały przyczyny, które pierwotnie uzasadniały wydanie pozwolenia.
          </p>
        </li>

        <li class="customAnswer">
          <h3>51. 🍺 Noszenie broni po alkoholu lub narkotykach</h3>
          <p>
            Ustawa o broni i amunicji zabrania noszenia broni przez osoby znajdujące się pod wpływem alkoholu, środków odurzających lub substancji psychoaktywnych. Naruszenie tego zakazu stanowi wykroczenie, za które grozi kara aresztu lub grzywny, a także może skutkować cofnięciem pozwolenia na broń przez Policję.
          </p>
        </li>

        <li class="customAnswer">
          <h3>52. 🌍 Wywóz broni za granicę</h3>
          <p>
            Wywóz broni palnej poza granice Polski wymaga uzyskania zezwolenia od właściwego organu Policji. W przypadku wyjazdu do innego kraju Unii Europejskiej możliwe jest skorzystanie z Europejskiej Karty Broni Palnej, która ułatwia legalne przewożenie broni w celach sportowych lub łowieckich, zgodnie z postanowieniami ustawy o broni i amunicji.
          </p>
        </li>

      </ul>


      <h2>🎯 Kryteria i dokumenty związane z pozwoleniem</h2>
      <ul className="reasonList">

        <li className={styles.customAnswer}>
          <h3>53. 🏅 Co uznaje się za ważną przyczynę wydania pozwolenia sportowego?</h3>
          <p>
            Za ważną przyczynę do uzyskania pozwolenia na broń do celów sportowych uznaje się aktywność w klubie strzeleckim, posiadanie odpowiednich kwalifikacji sportowych, takich jak uprawnienia zawodnika lub sędziego strzelectwa, a także aktualną licencję wydaną przez właściwy związek sportowy. Kandydat musi wykazać rzeczywiste zaangażowanie w działalność strzelecką, a nie jedynie formalną przynależność do organizacji.
          </p>
        </li>

        <li className={styles.customAnswer}>
          <h3>54. 🪪 Co potwierdza zarejestrowanie broni?</h3>
          <p>
            Zarejestrowanie broni palnej potwierdzają dwa dokumenty: legitymacja posiadacza broni oraz świadectwo broni. Legitymacja potwierdza uprawnienie do posiadania konkretnej sztuki broni, natomiast świadectwo broni zawiera szczegółowe dane identyfikacyjne broni i jest dokumentem ewidencyjnym, wymaganym przy jej przewożeniu lub prezentowaniu organom kontrolnym.
          </p>
        </li>

        <li className={styles.customAnswer}>
          <h3>55. ⏳ Termin ważności legitymacji uprawniającej do nabycia broni</h3>
          <p>
            Legitymacja uprawniająca do nabycia broni, wydawana przez właściwy organ Policji, jest ważna przez okres 3 miesięcy od dnia jej wystawienia. Po upływie tego terminu dokument traci moc, a osoba zainteresowana zakupem broni musi wystąpić o wydanie nowej legitymacji. Przekroczenie terminu uniemożliwia legalne nabycie broni na podstawie wygasłego dokumentu.
          </p>
        </li>

        <li className={styles.customAnswer}>
          <h3>56. 📅 Jak długo ważne jest świadectwo do nabycia broni?</h3>
          <p>
            Świadectwo uprawniające do nabycia określonej sztuki broni palnej zachowuje ważność przez 3 miesiące od dnia jego wystawienia. Jeżeli w tym czasie osoba nie sfinalizuje zakupu i nie przeprowadzi rejestracji broni, świadectwo traci ważność, a dalsze działania wymagają ponownego wystąpienia o nowy dokument. Terminowość jest tutaj kluczowa, by uniknąć dodatkowych formalności.
          </p>
        </li>

      </ul>


      <h2>🔐 Bezpieczeństwo na strzelnicy i w transporcie</h2>
      <ul className="reasonList">

        <li className={styles.customAnswer}>
          <h3>57. 🚨 Zgłoszenie zaginięcia broni</h3>
          <p>
            W przypadku zaginięcia broni lub podejrzenia jej utraty, należy natychmiast, bez zbędnej zwłoki, zawiadomić właściwy organ Policji. Zgłoszenie powinno być dokonane najpóźniej w ciągu 24 godzin od momentu stwierdzenia braku broni, aby ograniczyć ryzyko jej nieuprawnionego użycia i wynikających z tego zagrożeń.
          </p>
        </li>

        <li className={styles.customAnswer}>
          <h3>58. 👥 Kto może przebywać na stanowisku strzeleckim?</h3>
          <p>
            Na stanowiskach strzeleckich mogą przebywać wyłącznie osoby, które aktualnie korzystają ze strzelnicy oraz realizują strzelanie zgodnie z obowiązującymi zasadami bezpieczeństwa. Wstęp dla osób postronnych lub obserwatorów na stanowisko jest zabroniony, aby zminimalizować ryzyko wypadków.
          </p>
        </li>

        <li className={styles.customAnswer}>
          <h3>59. 🔓 Jak broń powinna być przechowywana poza stanowiskiem?</h3>
          <p>
            Poza stanowiskiem strzeleckim broń musi być zawsze rozładowana, z otwartą komorą nabojową oraz bez zamocowanego pasa czy pokrowca. Broń powinna być przenoszona w sposób widoczny, aby wszyscy obecni mogli upewnić się, że jest bezpieczna i nie stanowi zagrożenia.
          </p>
        </li>

        <li className={styles.customAnswer}>
          <h3>60. 🚌 Przewożenie broni w komunikacji publicznej</h3>
          <p>
            Przewożąc broń w środkach transportu publicznego, należy upewnić się, że jest całkowicie rozładowana — zarówno komora nabojowa, jak i magazynki muszą być puste. Broń powinna być zabezpieczona w pokrowcu lub futerale i nie może być łatwo dostępna dla osób postronnych.
          </p>
        </li>

        <li className={styles.customAnswer}>
          <h3>61. 🚆 Broń sportowa w transporcie publicznym</h3>
          <p>
            Broń sportowa przewożona środkami transportu publicznego musi być odpowiednio zabezpieczona, tak aby uniemożliwić jej przypadkowe użycie lub dostęp osobom nieuprawnionym. Transport musi odbywać się w sposób, który nie stwarza zagrożenia dla życia, zdrowia lub mienia.
          </p>
        </li>

        <li className={styles.customAnswer}>
          <h3>62. 🧳 Przewóz broni sportowej</h3>
          <p>
            Przewóz broni sportowej jest dozwolony pod warunkiem posiadania przy sobie wymaganych dokumentów — takich jak licencja sportowa i pozwolenie na broń. Broń powinna być transportowana w futerale lub pokrowcu, traktowana jako oddzielny bagaż i przewożona w sposób zapewniający bezpieczeństwo.
          </p>
        </li>

        <li className={styles.customAnswer}>
          <h3>63. 🔄 Korzystanie z cudzej broni na strzelnicy</h3>
          <p>
            Korzystanie z broni należącej do innej osoby na strzelnicy jest możliwe wyłącznie po uzyskaniu jej wyraźnej zgody. Użytkownik cudzej broni powinien przestrzegać wszystkich zasad bezpieczeństwa i ponosić odpowiedzialność za prawidłowe obchodzenie się z nią podczas użytkowania.
          </p>
        </li>

        <li className={styles.customAnswer}>
          <h3>64. 🚫 Alkohol i narkotyki na strzelnicy</h3>
          <p>
            Bezwzględnie zabronione jest spożywanie alkoholu oraz przebywanie pod wpływem środków odurzających lub psychotropowych na terenie strzelnicy. Osoby naruszające ten zakaz mogą zostać natychmiast usunięte z obiektu, a także ponieść konsekwencje prawne, w tym cofnięcie pozwolenia na broń.
          </p>
        </li>

        <li className={styles.customAnswer}>
          <h3>65. 🧍 Gdzie można wyjąć broń na strzelnicy?</h3>
          <p>
            Wyjmowanie broni z futerału lub kabury jest dozwolone wyłącznie bezpośrednio na stanowisku strzeleckim, pod warunkiem, że użytkownik jest przygotowany do rozpoczęcia strzelania. Wyciąganie lub manipulowanie bronią w innych częściach strzelnicy jest zabronione i grozi natychmiastowym wydaleniem z obiektu.
          </p>
        </li>

      </ul>
        <div className="buttonContainer">
          <button onClick={handleNext} className={styles.secondaryButton}>
            Kolejne
          </button>
          <button onClick={() => navigate('/')} className={styles.primaryButton}>
            Rozwiązuj testy na patent strzelecki
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExamQuestions4;
